// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/event-card/event-card.component.scss
// module id = 269
// module chunks = 0